/**
 * @generated SignedSource<<917e1f41b24f6edfd768b41db740d295>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listOfTopicsElementFragment$data = {
  readonly topics: ReadonlyArray<{
    readonly hidden: boolean | null;
    readonly items: ReadonlyArray<{
      readonly __typename: "HelpLayoutTopicItem";
    }> | null;
    readonly topicId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"topicCardFragment">;
  }> | null;
  readonly visualConfig: {
    readonly titleColor: string | null;
  } | null;
  readonly " $fragmentType": "listOfTopicsElementFragment";
};
export type listOfTopicsElementFragment$key = {
  readonly " $data"?: listOfTopicsElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"listOfTopicsElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "listOfTopicsElementFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "topicId"
        },
        {
          "kind": "ScalarField",
          "name": "hidden"
        },
        {
          "concreteType": "HelpLayoutTopicItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "topicCardFragment"
        }
      ]
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "titleColor"
        }
      ]
    }
  ],
  "type": "HelpLayoutTopicsListElement"
};

(node as any).hash = "00ae89e8e25628e5539a71375e02d691";

export default node;
